import apiService from './apiService';

/**
 * Ecommerce Brand Partner Service
 * Fetches authorized brand partners from the public /api/ecommerce endpoint (no auth required)
 */
class BrandPartnerService {
    /**
     * Fetch active brand partners configured by admin for the storefront.
     * Expected endpoint: GET /api/ecommerce/brand-partners
     *
     * Response shape:
     *   { success: true, data: { brandPartners: [ { _id, name, logo, website_url, display_order, is_active } ] } }
     *
     * Also supports alternative backend response keys gracefully:
     *   - data.brands
     *   - data.partners
     *   - data (array)
     *
     * @param {object} params - Optional query parameters
     * @returns {Promise<Array>} Array of brand partner objects
     */
    async getAll(params = {}) {
        try {
            const response = await apiService.get('/ecommerce/brand-partners', params);

            // Flexibly extract array across various standard response envelopes
            const candidates = [
                response?.data?.brandPartners,
                response?.data?.brands,
                response?.data?.partners,
                response?.brandPartners,
                response?.brands,
                Array.isArray(response?.data) ? response.data : null,
                Array.isArray(response) ? response : null,
            ];

            const list = candidates.find((arr) => Array.isArray(arr));
            return list || [];
        } catch (error) {
            console.warn(
                '[BrandPartnerService] Failed to load brand partners from API:',
                error?.message || error
            );
            throw error;
        }
    }
}

const brandPartnerService = new BrandPartnerService();
export default brandPartnerService;
